/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AIPlaygroundModelInput {
    getFixupPrototypeFunction() { return AIPlaygroundModelInput.fixupPrototype; }

    static newInstance(model: Partial<AIPlaygroundModelInput>): AIPlaygroundModelInput {
        let obj = Object.assign(new AIPlaygroundModelInput(), model);
        AIPlaygroundModelInput.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AIPlaygroundModelInput>): AIPlaygroundModelInput {
        if (!model) return null;
        return AIPlaygroundModelInput.newInstance(<AIPlaygroundModelInput> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AIPlaygroundModelInput) {
        if (!obj) return;

        models.AIPlaygroundModelInput.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AIPlaygroundModelInput): boolean {
        Object.setPrototypeOf(obj, AIPlaygroundModelInput.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.parameters) {
            models.AIPlaygroundParameters.fixupPrototype(this.parameters);
        }
    }

    /**
     * Bedrock model ID or inference profile ID
     */
    model_id: string;

    /**
     * Converse inference parameters
     */
    parameters: models.AIPlaygroundParameters;

    /**
     * AWS region
     */
    region: string;

}
